import styled from 'styled-components';

const LabelContainer = styled.div<any>`
  ${({ width = '50%' }) => {
    return `width: ${width}`;
  }};
`;

export default LabelContainer;
